exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container[data-v-84e2232c]{margin-top:2rem}@media (max-width:600px){.container[data-v-84e2232c]{margin-top:0;padding:.5rem;border-left:1px solid #eee}.mobileDescription[data-v-84e2232c]{font-size:.7rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-84e2232c&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/DaySummary.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-84e2232c&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/DaySummary.vue
// module chunks = 0